import { usePredictionsContext } from '@src/providers/PredictionsProvider';
import { IconName, type FilterableProperty } from '@talos/kyoko';
import { useMemo } from 'react';

/**
 * Filter property for prediction-outcome events.
 */
export function usePredictionEventsFilter() {
  const { events, eventsByID } = usePredictionsContext();

  return useMemo(
    () =>
      ({
        key: 'Events',
        label: 'Event',
        icon: IconName.CubeTransparent,
        control: 'multi-select',
        options: events.map(event => String(event.EventID)),
        getOptionLabel: (option: string) => eventsByID.get(option)?.EventName ?? option,
      }) as const satisfies FilterableProperty,
    [events, eventsByID]
  );
}
